var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.1875H8.25C7.9425 15.1875 7.6875 14.9325 7.6875 14.625C7.6875 14.3175 7.9425 14.0625 8.25 14.0625H15.75C16.0575 14.0625 16.3125 14.3175 16.3125 14.625C16.3125 14.9325 16.0575 15.1875 15.75 15.1875Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 9.9375H8.25C7.9425 9.9375 7.6875 9.6825 7.6875 9.375C7.6875 9.0675 7.9425 8.8125 8.25 8.8125H15.75C16.0575 8.8125 16.3125 9.0675 16.3125 9.375C16.3125 9.6825 16.0575 9.9375 15.75 9.9375Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 4.6875H8.25C7.9425 4.6875 7.6875 4.4325 7.6875 4.125C7.6875 3.8175 7.9425 3.5625 8.25 3.5625H15.75C16.0575 3.5625 16.3125 3.8175 16.3125 4.125C16.3125 4.4325 16.0575 4.6875 15.75 4.6875Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00002 5.43746C2.85752 5.43746 2.71502 5.38496 2.60252 5.27246L1.85252 4.52246C1.63502 4.30496 1.63502 3.94496 1.85252 3.72746C2.07002 3.50996 2.43002 3.50996 2.64752 3.72746L3.00002 4.07996L4.85252 2.22746C5.07002 2.00996 5.43002 2.00996 5.64752 2.22746C5.86502 2.44496 5.86502 2.80496 5.64752 3.02246L3.39752 5.27246C3.28502 5.38496 3.14252 5.43746 3.00002 5.43746Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00002 10.6875C2.85752 10.6875 2.71502 10.635 2.60252 10.5225L1.85252 9.77246C1.63502 9.55496 1.63502 9.19496 1.85252 8.97746C2.07002 8.75996 2.43002 8.75996 2.64752 8.97746L3.00002 9.32996L4.85252 7.47746C5.07002 7.25996 5.43002 7.25996 5.64752 7.47746C5.86502 7.69496 5.86502 8.05496 5.64752 8.27246L3.39752 10.5225C3.28502 10.635 3.14252 10.6875 3.00002 10.6875Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00002 15.9375C2.85752 15.9375 2.71502 15.885 2.60252 15.7725L1.85252 15.0225C1.63502 14.805 1.63502 14.445 1.85252 14.2275C2.07002 14.01 2.43002 14.01 2.64752 14.2275L3.00002 14.58L4.85252 12.7275C5.07002 12.51 5.43002 12.51 5.64752 12.7275C5.86502 12.945 5.86502 13.305 5.64752 13.5225L3.39752 15.7725C3.28502 15.885 3.14252 15.9375 3.00002 15.9375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckList);
export default __webpack_public_path__ + "static/media/check-list.e89d21dc9b23bf722183c4bc92ae7274.svg";
export { ForwardRef as ReactComponent };